import { services } from "@/mocks/homeData";
import { useEffect, useRef, useState } from "react";

export default function ServicesSection() {
  const sectionRef = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const el = sectionRef.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.unobserve(el);
        }
      },
      { threshold: 0.15 }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <section
      id="services"
      ref={sectionRef}
      className="py-16 md:py-24 bg-white"
    >
      <div className="px-4 md:px-8 lg:px-12 max-w-6xl mx-auto">
        <div
          className={`text-center mb-12 md:mb-16 transition-all duration-700 ${
            visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
          }`}
        >
          <span className="inline-block px-4 py-1.5 rounded-full bg-red-50 text-red-700 text-xs font-semibold tracking-wider uppercase mb-4">
            What We Remove
          </span>
          <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl text-dark-950 mb-4">
            We Take It All Off
          </h2>
          <p className="text-dark-400 max-w-2xl mx-auto text-sm md:text-base leading-relaxed">
            Using the Fair Credit Reporting Act of 1984, we aggressively dispute negative items on your credit report from all three bureaus.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {services.map((service, index) => (
            <div
              key={service.id}
              className={`group p-6 md:p-7 rounded-xl bg-dark-50 hover:bg-white border border-transparent hover:border-red-200 transition-all duration-500 hover:shadow-lg hover:shadow-red-50/50 cursor-default ${
                visible
                  ? "opacity-100 translate-y-0"
                  : "opacity-0 translate-y-6"
              }`}
              style={{ transitionDelay: visible ? `${index * 120}ms` : "0ms" }}
            >
              <div className="w-12 h-12 rounded-lg bg-red-600 flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300">
                <i className={`${service.icon} text-white text-xl`} />
              </div>
              <h3 className="font-heading font-semibold text-lg text-dark-950 mb-1">
                {service.title}
              </h3>
              <div className="text-red-600 text-xs font-bold tracking-wider uppercase mb-3">
                {service.timeline}
              </div>
              <p className="text-dark-400 text-sm leading-relaxed">
                {service.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}